import { getUserProfile } from 'helpers/userProfile';
import { ReactElement, useState } from 'react';
import { ClientSelectionInfo } from './components/ClientSelectionInfo';
import { Filter } from './components/Filter';
import { OverviewContent } from './Content';
import { useFilterContext } from './contexts/FilterContext';
import { HealthDataProvider } from './contexts/HealthDataContext';
import { ThermalComfortDataProvider } from './contexts/ThermalComfortDataContext';
import { HeaderContainer, OverviewContainer } from './styles';

export function OverviewLayout(): ReactElement {
  const [profile] = useState(getUserProfile);
  const { client } = useFilterContext();

  const needSelectClient = profile.manageMultipleClients && !client;

  return (
    <HealthDataProvider>
      <ThermalComfortDataProvider>
        <OverviewContainer>
          <HeaderContainer>
            <Filter />
          </HeaderContainer>
          {needSelectClient ? (
            <ClientSelectionInfo />
          ) : (
            <OverviewContent />
          )}
        </OverviewContainer>
      </ThermalComfortDataProvider>
    </HealthDataProvider>
  );
}
